export const generateMongoFilter = ({ filters, searchFullDocument = false }) => {
    const filter = {};
    for (const key in filters) {
        if (filters[key]) {
            if (searchFullDocument) {
                filter[`fullDocument.${key}`] = filters[key];
            } else {
                filter[key] = filters[key];
            }
        }
    }

    return filter;
};

